/* eslint-disable max-len */
import React from "react";
import Button from "../../../components/Button";

export default function Confirmationpopup({ message, Title, handleSubmit, loading, handleClick, handleClose, stateKey, extraText, closeIcon, additionalText, disabled = false }) {
    const he = 1;
    return (
        <div className="p-2 w-full bg-white ">
            <div className="flex pb-4 justify-between">
                <h1 className="text-lg font-normla text-[#1f1f1f]">
                    {Title}
                </h1>
                {closeIcon && <img src="/assets/images/close-icon.svg" onClick={handleClose} alt="" />}
            </div>
            <p className={`text-sm font-normal text-[#4B4B4B] ${extraText && 'w-[352px]'}`}>
                {message}<br></br>
                {extraText}<br></br>
                {additionalText}
            </p>
            <div className="flex justify-end space-x-2 mt-6">
                <button className="px-4 py-[10px] rounded-[12px] text-primary" data-testid="cancel-btn" onClick={() => handleClose()}>Cancel</button>
                <>
                    <Button
                        handleClick={handleSubmit}
                        loading={loading}
                        disabled={disabled || loading}
                        text={Title.split(' ')[0]}
                        classKey="px-4 py-[10px] bg-primary text-white w-[100px] rounded-[12px]"
                        type="submit"
                        testId="confirm-btn"

                    /></>
            </div>
        </div>
    );
}
